import { Card, CardActions, IconButton, Menu, MenuItem, Radio } from '@mui/material';
import Avatar from '../Avatar';
import React, { useEffect, useState } from 'react';

const User = ({ user, onDelete, active, selectable = false, isSelected = false, onSelect = () => ({}) }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [showOptions, setShowOptions] = useState(false);
    const [userDetails, setUserDetails] = useState({});

    const handleCardOptions = (e) => {
        setAnchorEl(e.currentTarget);
        setShowOptions(true);
    };

    useEffect(() => {
        if (user && Object.keys(user).length > 0) {
            let userId = user.id;
            if (user && user.user_id) {
                userId = user.user_id;
            }
            const tmp = {
                id: userId,
                profile_pic: user.profile_pic,
                profile_photo_updated_at: user.profile_photo_updated_at
            };
            setUserDetails(tmp);
        }
    }, [user]);

    return <Card
        className={`user__card
            ${active && active.id == user.id ? ' user__card-active' : ''}
            ${selectable && isSelected ? ' user__card-selected' : ''}
            ${selectable ? ' user__card-selectable' : ''}
        `}
        onClick={() => onSelect(user)}
        variant='outlined'
    >
        <div className={`user__details${selectable && isSelected ? ' pr-3' : ''}`}>
            {
                selectable && isSelected ? <span className='user__details-selected'><i className="fa-sharp fa-light fa-circle-check"></i></span> : ''
            }
            <div className='user__avatar'>
                <Avatar
                    pu={userDetails}
                    size='30'
                    story={false}
                    showOnline
                />
            </div>
            <div className='user__name'>
                {user.login}
            </div>
            <div>
                {
                    !selectable ? <React.Fragment>
                        <IconButton aria-label="remove from list" onClick={handleCardOptions}>
                            <i className="fa-regular fa-ellipsis-vertical"></i>
                        </IconButton>
                        <Menu
                            anchorEl={anchorEl}
                            id="user-options"
                            open={showOptions}
                            onClose={() => setShowOptions(false)}
                            MenuListProps={{
                                'aria-labelledby': 'user-options',
                            }}
                            dense={true}
                            sx={{
                                zIndex: 999999
                            }}
                        >
                            <MenuItem onClick={() => {
                                setShowOptions(false);
                                onDelete(user);
                            }}>
                                Remove
                            </MenuItem>
                        </Menu>
                    </React.Fragment>
                        : ''
                }
            </div>
        </div>
    </Card>;
};

export default User;